import React from 'react';
import {Controller, FieldError, UseFormMethods} from 'react-hook-form';
import {HelpCenterPageCommonProps} from '../../../../pages/HelpCenter/types';
import DropdownSelect from '../../../Forms/Inputs/DropdownSelect';
import {FormErrors} from '../types';
import {FormSection} from './styled';

interface Props {
  control: UseFormMethods['control'];
  labels: {
    required: string;
    contact_reason: string;
  };
  errors: FormErrors;
  sections: HelpCenterPageCommonProps['sections'];
}

interface ItemValue {
  id: number;
  name: string;
}

export const SubjectSection = ({control, labels, errors, sections}: Props) => {
  return (
    <FormSection short data-testid="hcSectionDropdownWrapper">
      <Controller
        name="subject"
        control={control}
        rules={{required: labels.required}}
        render={({onChange, value}) => (
          <DropdownSelect<ItemValue>
            errorMessage={(errors.subject as FieldError | undefined)?.message}
            id={'contact-reason-select'}
            label={labels.contact_reason}
            items={sections.map(section => ({
              label: section.name,
              value: {
                id: section.id,
                name: section.name,
              },
            }))}
            onChange={onChange}
            value={value}
            data-testid="hcSectionDropdown"
          ></DropdownSelect>
        )}
      />
    </FormSection>
  );
};
